import React, { useEffect } from 'react';
import 'photoswipe/style.css';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/dist/photoswipe.css';

const ImageGallery = ({ data, onClosed }) => {
  useEffect(() => {
    if (!data || data.type !== "images") return;
    const images = data.link;
    let lightbox = new PhotoSwipe({
      dataSource: images,
      index: 0,
      showHideAnimationType: 'fade',
      pswpModule: () => import('photoswipe'),
    });
    lightbox.on('contentDestroy', () => {
      if (onClosed) onClosed();
    })

    lightbox.init();

    // return () => {
    //   lightbox.destroy();
    //   lightbox = null;
    // };
  }, [data, onClosed]);

  return (<div id="galleryWrapper"></div>)
}

export default ImageGallery;
